export const AUTH = "auth";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const GET_CURRENT_USER = "GET_CURRENT_USER";
export const REDIRECT_ON_LOGIN = "REDIRECT_ON_LOGIN";
